<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-bottom:15px;">About the Author</h1>
<p style="text-indent:0em;">Jason was born in Pittsburgh Pennsylvania in 1974. Since he was eight years old, he delved into science fiction and fantasy, following the works of J.R.R. Tolkien and Gary Gygax. His favourite book however, is <em>Great Expectations</em> by Charles Dickens. Jason began writing during his many deployments and travels as a member of the United States Air Force. After travelling all over Europe and the Middle East for nearly 24 years in the military, he is ready to put writing at the forefront of his life. Jason’s true motivations are his daughters Eve and Ella who have read more books by the time they became teenagers than he had in his entire life!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?24480d46